/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreditCardOrderResponseViewModel } from "../types/CreditCardOrderResponseViewModel.ts";
import { creditCardLimitResponseViewModelSchema } from "./creditCardLimitResponseViewModelSchema.ts";
import { creditCardOrderAddressResponseViewModelSchema } from "./creditCardOrderAddressResponseViewModelSchema.ts";
import { creditCardOrderCustomerResponseViewModelSchema } from "./creditCardOrderCustomerResponseViewModelSchema.ts";
import { creditCardOrderItemResponseViewModelSchema } from "./creditCardOrderItemResponseViewModelSchema.ts";

export const creditCardOrderResponseViewModelSchema = z.object({
  id: z.optional(z.string().uuid()),
  idExternal: z.string().nullish(),
  createdAt: z.optional(z.string().datetime()),
  updatedAt: z.string().datetime().nullish(),
  amountPaid: z.number().nullish(),
  amount: z.optional(z.number()),
  status: z.string().nullish(),
  issueInvoice: z.optional(z.boolean()),
  issueReceipt: z.optional(z.boolean()),
  companyBillingDocument: z.string().nullish(),
  paymentMethod: z.string().nullish(),
  items: z
    .array(z.lazy(() => creditCardOrderItemResponseViewModelSchema))
    .nullish(),
  billingAddress: z.optional(
    z.lazy(() => creditCardOrderAddressResponseViewModelSchema),
  ),
  customer: z.optional(
    z.lazy(() => creditCardOrderCustomerResponseViewModelSchema),
  ),
  creditCardLimit: z
    .array(z.lazy(() => creditCardLimitResponseViewModelSchema))
    .nullish(),
}) as unknown as ToZod<CreditCardOrderResponseViewModel>;
